<script>
	import { onMount, tick } from 'svelte';
	import { DialogNew, Icon } from '@shopboxai/sb-portal-components';
	import CustomProductsSelect from '../../CustomProductsSelect.svelte';
	import { createEventDispatcher } from 'svelte';
	export let data = [];
	const dispatch = createEventDispatcher();
	const submitDialog = () => {
		console.log(data);
		dispatch('submit', data);
	};
</script>

<DialogNew on:submit={submitDialog} on:close>
	<button slot="toggle" class="primary dialog-toggle "
		><Icon name="add" /> Add custom products
	</button>
	<div slot="content" class="wrapper">
		<CustomProductsSelect bind:customProducts={data} />
	</div>
	<div slot="header">Add custom products</div>
	<button class="primary" slot="primary-action">Save Custom Products</button>
</DialogNew>

<style>
	.dialog-toggle {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
	}
	.primary {
		padding: 10px 16px 9px !important;
	}
	.dialog-toggle :global(svg) {
		transform: translateY(2px);
	}
	.dialog-toggle :global(svg path) {
		stroke: #fff;
	}
</style>
